module.exports = __webpack_public_path__ + "img/banner6.1c30f703.png";